/* Floky Clean — theme.js
   Handles: product variant selection, price/availability updates, gallery thumbs. */

(function () {
  'use strict';

  /* ---------- Product form: variant picker ---------- */

  document.querySelectorAll('[data-product-form]').forEach(function (wrapper) {
    var variantsEl = wrapper.querySelector('[data-variants-json]');
    if (!variantsEl) return;

    var variants;
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (e) {
      return;
    }

    var selects = wrapper.querySelectorAll('[data-option-select]');
    var idInput = wrapper.querySelector('[data-variant-id]');
    var priceEl = wrapper.querySelector('[data-price]');
    var compareEl = wrapper.querySelector('[data-compare-price]');
    var buyBtn = wrapper.querySelector('[data-add-to-cart]');
    var moneyFormat = wrapper.getAttribute('data-money-format') || '£{{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function currentVariant() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function update() {
      var variant = currentVariant();

      if (!variant) {
        if (buyBtn) {
          buyBtn.disabled = true;
          buyBtn.textContent = buyBtn.getAttribute('data-text-unavailable') || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (buyBtn) {
        if (variant.available) {
          buyBtn.disabled = false;
          buyBtn.textContent = buyBtn.getAttribute('data-text-add') || 'Add to cart';
        } else {
          buyBtn.disabled = true;
          buyBtn.textContent = buyBtn.getAttribute('data-text-soldout') || 'Sold out';
        }
      }

      /* Swap gallery image if the variant has one */
      if (variant.featured_image && variant.featured_image.src) {
        var mainImg = document.querySelector('[data-main-image]');
        if (mainImg) mainImg.src = variant.featured_image.src;
      }

      /* Keep URL shareable */
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url.toString());
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });

  /* ---------- Product gallery thumbnails ---------- */

  var mainImage = document.querySelector('[data-main-image]');
  if (mainImage) {
    document.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mainImage.src = btn.getAttribute('data-thumb');
        if (btn.getAttribute('data-alt')) mainImage.alt = btn.getAttribute('data-alt');
        document.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  /* ---------- Close mobile nav when a link is chosen ---------- */

  document.querySelectorAll('.mobile-nav__panel a').forEach(function (link) {
    link.addEventListener('click', function () {
      var details = link.closest('details');
      if (details) details.removeAttribute('open');
    });
  });
})();
